import styled from 'styled-components';
import { palette } from 'styled-theme';

export const DashboardLayout = styled.div`
  min-height: 100vh;
  background-color: ${palette('background', 0)};
`;

export const MainContent = styled.main`
  margin-left: ${(props) => (props.isCollapsed ? '80px' : '256px')};
  margin-top: 64px;
  padding: 30px;
  min-height: calc(100vh - 64px);
  transition: margin-left 0.3s ease;
  position: relative;
`;

export const ContentHeader = styled.div`
  margin-bottom: 48px;
`;

export const PageTitle = styled.h1`
  font-family: 'Manrope', sans-serif;
  font-size: 24px;
  font-weight: 400;
  color: #1a1b24;
  letter-spacing: -1.2px;
  line-height: 48px;
  margin: 0;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;
